<template>
    <div id="Header" class="headerMcp mcp HeaderHydrates">
        <header class="header ">
            <div class="header-content">

                <div class="header-content__flex">
                    <!-- MENU MOBILE -->
                    <span 
                        id="jade_hamb" 
                        class="jade-hamburger jade-hamburger-cross"
                        @click="toggleMenuMobile" 
                        data-hamb="1">
                        <span class="menu-hamb">Menu</span>
                    </span>

                    <!-- LOGO -->
                    <h1 v-if="isHome" id="logo_home" class="logo">
                        <strong>Mon Chauffagiste Privé</strong>
                        <img :src="baseUrl+'/skin/frontend/mcp/default/images/logo.svg'" alt="Mon Chauffagiste Privé">
                    </h1>
                    <a v-else :href="baseUrl" title="monchauffagisteprive" id="logo_home" class="logo">
                        <strong>Mon Chauffagiste Privé</strong>
                        <img :src="baseUrl+'/skin/frontend/mcp/default/images/logo.svg'" alt="Mon Chauffagiste Privé">
                    </a>
                </div>

                <!-- SearchBar-->
                <Search-bar></Search-bar>

                <!-- Verified Reviews -->
                <VerifiedReviews 
                    v-if="verifiedReviewsDatas.display == '1'"
                    :verifiedReviewsDatas="verifiedReviewsDatas"
                    :baseUrl="baseUrl"
                ></VerifiedReviews>

                <!-- PHONE Number-->
                <PhoneNumber
                    v-if="phoneNumberDatas.display == '1'"
                    :phoneNumberDatas="phoneNumberDatas"
                    :baseUrl="baseUrl"
                ></PhoneNumber>
                
                <!-- RIGHT -->
                <div class="header-content__right">
                    <div class="top-link-menu">
                        <ul class="top-links-list">

                            <!-- ACCOUNT -->
                            <li class="top-links-list__account">
                                <ObfuscateLink v-if="isObfuscate" :dataHref="baseUrl+'/customer/account/'" :idName="'top-link-customer'" :class="'top-link-customer'">
                                    <template v-slot:content>
                                        <i class="icon icon-user"></i>
                                        <span v-if="currentUser.lastname" class="account-item">{{ currentUser.prefix}} {{ currentUser.lastname}}</span>
                                        
                                        <span v-else class="account-item">
                                            <span>Compte</span>  
                                        </span>
                                    </template>
                                </ObfuscateLink>
                                <a v-else :href="baseUrl+'/customer/account/'" title="Mon compte" class="top-link-customer" id="top-link-customer">
                                    <i class="icon icon-user"></i>
                                    <span v-if="currentUser.lastname" class="account-item">{{ currentUser.prefix}} {{ currentUser.lastname}}</span>
                                    
                                    <span v-else class="account-item">
                                        <span>Compte</span>  
                                    </span>
                                </a>

                                <Login
                                    :baseUrl="baseUrl"
                                    :isLogged="currentUser.lastname ? true : false"
                                >
                                </Login>
                            </li>

                            <!-- COMPARE -->
                            <li class="first mycompare ">
                                <ObfuscateLink v-if="isObfuscate" :dataHref="baseUrl + '/catalog/product_compare/'" :idName="'top-link-comparator'" :class="'top-link-mycompare'">
                                    <template v-slot:content>
                                        <i class="icon icon-compare"></i>
    
                                        <!-- Items compare count --> 
                                        <span v-if="currentItemsInCompare.length > 0" class="compare-item_nb compare-number-products">
                                            {{ currentItemsInCompare.length }}
                                        </span>
                                        <span v-else style="display:none" class="compare-item_nb compare-number-products"></span>
    
                                        <span class="compare-item">
                                            Comparer
                                        </span>
                                    </template>
                                </ObfuscateLink>
                                <a v-else :href="baseUrl + '/catalog/product_compare/'" title="Mon comparateur" class="top-link-mycompare" id="top-link-comparator">
                                    <i class="icon icon-compare"></i>

                                    <!-- Items compare count --> 
                                    <span v-if="currentItemsInCompare.length > 0" class="compare-item_nb compare-number-products">
                                        {{ currentItemsInCompare.length }}
                                    </span>
                                    <span v-else style="display:none" class="compare-item_nb compare-number-products"></span>

                                    <span class="compare-item">
                                        Comparer
                                    </span>
                                </a>
                            </li>

                            <!-- CART -->
                            <li class="top-links-list__cart">
                                <div 
                                    v-if="cartItemsCount > 0"
                                    id="my-cart-link" 
                                    class="my-cart-link"
                                >
                                    <ObfuscateLink v-if="isObfuscate" :dataHref="baseUrl + '/checkout/cart/'" :idName="'top-link-cart'" :class="'top-link-cart'">
                                        <template v-slot:content>
                                            <i class="icon icon-cart"></i>
                                            
                                            <span class="cart-item">
                                                <span>Panier</span>
                                                <span v-if="cartItemsCount > 0" class="headerCart-item_nb"> ({{ cartItemsCount }}) </span>
                                            </span>
                                        </template>
                                    </ObfuscateLink>
                                    <a v-else :href="baseUrl + '/checkout/cart/'" title="Mon panier" id="top-link-cart" class="top-link-cart">
                                        <i class="icon icon-cart"></i>
                                        
                                        <span class="cart-item">
                                            <span>Panier</span>
                                            <span v-if="cartItemsCount > 0" class="headerCart-item_nb"> ({{ cartItemsCount }}) </span>
                                        </span>
                                    </a>
                                </div>
                            </li>
                        </ul>               
                    </div>
                </div>

            </div>
        </header>

        <Menu 
            v-if="menuLoaded"
            :mobileState="openMenu"
            :menuDatas="menuDatas"
        ></Menu>
        <Skeleton v-else ></Skeleton>
    </div>
</template>

<script>
import SearchBar from '@/includes/Header/SearchBar/SearchBar.vue';
import VerifiedReviews from '@/includes/Header/VerifiedReviews/VerifiedReviews.vue';
import PhoneNumber from '@/includes/Header/PhoneNumber/PhoneNumber.vue';
import Menu from '@/components/Header/Menu/Menu.vue';
import Login from '@/includes/Header/Login/Login.vue';
import ObfuscateLink from '@/components/ObfuscateLink/ObfuscateLink.vue';
import Skeleton from "@/components/Skeleton/Skeleton.vue";
import "@/globals.js";
import './Headervue.scss';
import InstanceApi from "@/services/apiClient.js";
import { mapGetters, mapActions } from "vuex";

export default {
    name: 'Headervue',

    components: { 
        SearchBar,
        Menu,
        Login,
        VerifiedReviews,
        PhoneNumber,
        ObfuscateLink,
        Skeleton
    },

    props: {
        isHome: {
            type: Boolean,
            default: false,
            required: false,
        },
        isObfuscate: false
    },

    data() {
        return {
            openMenu: false,
            menuLoaded: false,
            baseUrl: process.env.VUE_APP_API_BASE_URL,
            menuDatas: {},
            verifiedReviewsDatas: {},
            phoneNumberDatas: {},
            currentUser: {},
            comparItemsCount: 0,
            cartItemsCount: 0,
        };
    },

    computed: {
        ...mapGetters({ getCartItemsCount: "getCurrentCartTotalItemsQty" }),
        ...mapGetters({ currentItemsInCompare: "getItemsInComparator" }),
    },

    watch: {
        getCartItemsCount() {
            this.cartItemsCount = this.getCartItemsCount
        },
    },

    methods: {
        ...mapActions(["setAddItemInComparator"]),

        async fetchHeaderDatas() {
            try {
                const response = await InstanceApi.get("mcp/header/get/");
                
                this.menuDatas = response.data.categories;
                this.verifiedReviewsDatas = response.data.components.verified_reviews;
                this.currentUser = response.data.customer;
                this.phoneNumberDatas = response.data.components.phone_number;
                this.cartItemsCount = response.data.items.nb_items_in_cart;
                this.setDateFromServer(response.headers.date);

                this.menuLoaded = true;
                
                // Product Id in comparator
                if(response.data.items.items_in_comparator && response.data.items.items_in_comparator.length > 0) {
                    response.data.items.items_in_comparator.forEach(item => {
                        this.setAddItemInComparator(item)
                    });
                }
            }
            catch(error) {
                this.menuLoaded = true;
                console.error(error)
            }
        },

        toggleMenuMobile() {
            this.openMenu = !this.openMenu;
        },

        /**
         * Listen sub-menu cta and list-link in html block from BO
         */
        gtmElementsListener() {
            let fullCmsLink         = document.querySelectorAll('#Header .submenu-fullcms a');
            let ctaSubMenu          = document.querySelectorAll('#Header .submenu-cta a');
            let linkItems           = document.querySelectorAll('#Header .submenu-content a');
            let firstLevelsItems    = document.querySelectorAll('#Header .gtm-element');
            let headerRightContent  = document.querySelectorAll('#Header  header.header a')

            let elementsToListen = [...ctaSubMenu, ...linkItems, ...fullCmsLink, ...firstLevelsItems, ...headerRightContent];

            elementsToListen.forEach(element => {
                element.addEventListener('click', (e) => {
                    
                    // Else redirect to account page
                    if(!element.classList.contains('top-link-customer')) e.stopPropagation();
                    
                    
                    let gtmDatasToSave;

                    if(element.classList.contains('gtm-element')) {
                        gtmDatasToSave = {
                            id: element.id ?? '',
                            element_text: element?.dataset?.gtmtext ?? '',
                            link_url: element?.dataset?.gtmlink ?? '',
                        }
                    } else {
                        gtmDatasToSave = {
                            element_id: element.id ?? '',
                            element_text: element.innerText ?? '',
                            link_url: element.href ?? '',
                        };
                    }
                    
                    
                    if(window.McpGtm) McpGtm.pushCustomDataLayerWithoutModel('click_header', gtmDatasToSave);
                }) 
            })
        },

        // Remove the skeleton loader from magento page (view.phtml)
        removeSkeleton() {
            const isBoilerProductPage = document.body.classList.contains('catalog-product-view') 
                                        && (document.body.classList.contains('category-chaudieres-gaz') || document.body.classList.contains('category-chaudieres'))
            // Catalog page
            if(document.body.classList.contains('catalog-category-view')) {
                document.body.classList.add('catalog-loaded');
            }

            // Prouct page chaudieres
            if(isBoilerProductPage) {
                document.body.classList.add('product-loaded');
            }
        },

        ...mapActions(["setDateFromServer", "setDateFromServer"]),
    },

    async created() {
        await this.fetchHeaderDatas();
        this.gtmElementsListener();
    },

    mounted() {
        if( document.getElementById('Header').classList.contains('catalog-category-view') ){
            this.isObfuscate = true;
        }
        if( document.getElementById('Header').classList.contains('catalog-product-view') ){
            this.isObfuscate = true;
        }
        if( document.querySelector('body').classList.contains('cms-index-index') ) {
            this.isHome = true;
        }

        this.removeSkeleton();
    },

}
</script>

<style lang="scss" scoped>
    //Only when header vue is loaded
    body.mini-website .jade-hamburger {
        @include breakpoint(only-md) {
            display: block;
        }
    }
</style>